//mui
import {Theme} from '@mui/material';

export const MuiFormHelperText = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			textAlign: 'right' as any,
			position: 'absolute' as any,
			bottom: '-20px',
			right: 12,
			marginTop: 0,

			'&.Mui-error': {
				color: `${theme.palette.error500}`,
			},
		}),
	},

	variants: [
		{
			props: {variant: 'standard'},
			style: {
				color: 'var(--primary-500)',
				cursor: 'pointer',
			},
		} as any,
	],
};
